import { render, staticRenderFns } from "./SubmissionRestrictedAlert.vue?vue&type=template&id=1156f515&scoped=true&"
import script from "./SubmissionRestrictedAlert.vue?vue&type=script&lang=js&"
export * from "./SubmissionRestrictedAlert.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionRestrictedAlert.vue?vue&type=style&index=0&id=1156f515&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1156f515",
  null
  
)

export default component.exports